export default __webpack_public_path__ + "static/product-1-b724f4e53b6494c8c6f58da5b570696d.png";